<template>
	<div class="adminDiscount">
		<div class="d-flex flex-row justify-content-between">
			<div class="search-input">
				<b-form-input
					class="input-search"
					:placeholder="$t('userDashboard.messages.search')"
					v-model="config.searchAdminMedia"
				></b-form-input>
				<MagnifyIcon class="icon-search" />
			</div>
			<b-button class="add-button ml-3" v-b-modal.add-discount @click="createDiscountCode()">{{$t('adminMedia.addFile')}}</b-button>
		</div>
		<div
			class="content-body-div"
			:class="{ 'no-data': !listOfDiscountCodes.length }"
		>
			<b-row no-gutters v-if="listOfDiscountCodes.length">
				<template v-for="(item, index) in listOfDiscountCodes">
					<b-col cols="4" :key="index">
						<div class="template-item">
							<b-row align-content="start" class="justify-content-between my-1">
								<b-col class="text-left">
									<span style="font-size:18px;color:#626262;    font-weight: bold; ">{{item.code}}</span>
								</b-col>
								<b-col class="text-right">
									<b-form-checkbox v-model="item.is_active" name="check-button" switch @change="updateEnabaleOrDisable(item)">
										
									</b-form-checkbox>
								</b-col>
							</b-row>
							<b-row align-content="start" class="justify-content-start my-1">
								<b-col class="text-left"><span style="font-size:16px;color:#626262;    font-weight: bold; ">{{$t('discountList.amount')}}</span></b-col>
								<b-col class="text-left">{{item.amount}} {{item.is_fix_amount?$t('baht'):'%'}}</b-col>
							</b-row>
							<b-row align-content="start" class="justify-content-start my-1">
								<b-col class="text-left" cols="12"><span style="font-size:16px;color:#626262;    font-weight: bold; ">{{$t('discountList.available')}}</span></b-col>
								<b-col class="text-left" cols="12">{{item.start_date}} - {{item.expire_date}}</b-col>
							</b-row>
							<b-row align-content="start" class="justify-content-start my-1">
								<b-col class="text-left" ><span style="font-size:16px;color:#626262;    font-weight: bold; ">Usages</span></b-col>
								<b-col class="text-left" >{{item.amount_uses}}</b-col>
							</b-row>
							<b-row  align-content="start" class="justify-content-end" style="margin-top:20px;">
								<b-col class="text-left">
									<span class="mif-coins" v-if="!item.is_listing" style="font-size:26px;color:#626262;"></span>
									<IconHotel v-else style="width: 26px;color:#626262;"/>
								</b-col>
								
								<b-col style="padding:0"> 
									<b-row>
										<b-button @click="editDiscountCode(item)"  class="btn-grid" v-if="parseInt(item.amount_uses)<=0"><IconEdit/></b-button>
										<b-button @click="deleteDiscountCode(item)" class="btn-grid delete-btn" v-if="parseInt(item.amount_uses)<=0"><IconTrash/></b-button>
									</b-row>
								</b-col>
							</b-row>
							
						</div>
					</b-col>
				</template>
			</b-row>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results">
					<b-alert show variant="light">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert>
				</span>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
		<b-modal
			id="add-discount"
			modal-class="modal-adminDiscount-template"
			centered
			hide-header
			hide-footer
			no-close-on-backdrop
			no-close-on-esc
		>
			<b-form
				class="needs-validation"
				novalidate
				id="form-add-address"
				@submit.prevent="
					openDialogForEdit ? updateDiscountCode() : creatDiscountCode()
				"
			>
				<div class="wrapper">
					<b-row>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.discountType')}}</label>
								<b-dropdown no-flip
									class="menu-dropdown"
									v-model="createDiscountCodeObj.discountType"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.discountType.$error }"
									>
									<template v-slot:button-content>
										<span v-if="!createDiscountCodeObj.discountTyp">
											{{$t('discountList.dialog.select')}}
										</span>
										<span v-if="createDiscountCodeObj.discountType==1">
											{{$t('discountList.dialog.Discount For Listing Package')}}
										</span>
										
										<span v-if="createDiscountCodeObj.discountType==2">
											{{$t('discountList.dialog.Discount For Coin')}}
										</span>
										<span v-if="createDiscountCodeObj.discountType==3">
											{{$t('discountList.dialog.Discount For Agency Package')}}
										</span>
										<ChevronDownIcon />
									</template>

									<b-dropdown-item
										value="2"
										@click="createDiscountCodeObj.discountType = 2"
										>{{$t('discountList.dialog.Discount For Coin')}}</b-dropdown-item
									>
									<b-dropdown-item
										value="1"
										@click="createDiscountCodeObj.discountType = 1"
										>{{$t('discountList.dialog.Discount For Listing Package')}}</b-dropdown-item
									>
									<b-dropdown-item
										value="1"
										@click="createDiscountCodeObj.discountType = 3"
										>{{$t('discountList.dialog.Discount For Agency Package')}}</b-dropdown-item
									>
								</b-dropdown>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please select discount type')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.discountForPackage')}}</label>
								<b-dropdown no-flip
									class="menu-dropdown"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.discountForPackage.$error }"
									:disabled="!packagesItem.length"
									>
									<template v-slot:button-content>
										<span v-if="createDiscountCodeObj.discountType==1">
										{{
											createDiscountCodeObj.discountType
											? $t('discountList.dialog.Discount For Listing Package')
											: $t('discountList.dialog.select')
										}}
										<ChevronDownIcon />
										</span>
										<span v-if="createDiscountCodeObj.discountType==2">
										{{
											createDiscountCodeObj.discountType
											? $t('discountList.dialog.Discount For Coin')
											: $t('discountList.dialog.select')
										}}
										<ChevronDownIcon />
										</span>
										<span v-if="createDiscountCodeObj.discountType==3">
										{{
											createDiscountCodeObj.discountType
											? $t('discountList.dialog.Discount For Agency')
											: $t('discountList.dialog.select')
										}}
										<ChevronDownIcon />
										</span>
										
									</template>
									<div label-for="dropdown-form-email" @submit.stop.prevent v-if="packagesItem.length">
										<template v-for="(item,key) in packagesItem"  >
											<b-button 
												v-if="item.packages_details.length"
												v-b-toggle="'accordion-'+key"  
												:key="'a'+key" class="d-flex flex-row justify-content-between" 
												style="width:100%;">
												<span>{{$t(item.name)}}</span>
												<span class="when-opened">
													<ChevronUpIcon />
												</span>
												<span class="when-closed">
													<ChevronDownIcon />
											</span>
											</b-button>
											<b-form-checkbox-group v-model="createDiscountCodeObj.discountForPackage" 
												:key="key"
												v-else
												 class="d-flex flex-column ml-3 pa-3">
													<b-form-checkbox
														:id="'checkbox-'+item.id"
														:name="'checkbox-'+item.id"
														:value="item.id"
													>
															{{$t(item.name)}} {{item.id}}
													</b-form-checkbox>
												 </b-form-checkbox-group>
											<b-collapse :id="'accordion-'+key" role="tabpanel" :key="'b'+key">
												 
												<b-form-checkbox-group v-model="createDiscountCodeObj.discountForPackage" 
												 class="d-flex flex-column ml-3 pa-3">
													<b-form-checkbox
														:id="'checkbox-'+subItem.id"
														:name="'checkbox-'+subItem.id"
														v-for="subItem in item.packages_details"
														:key="subItem.id"
														:value="subItem.id"
													>
															{{subItem.num_days}}{{$t('day')}} - {{subItem.price}}{{ $t('baht') }}
													</b-form-checkbox>
												 </b-form-checkbox-group>
											</b-collapse>
											
										</template>
									</div> 
								</b-dropdown>
								
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please select package')}}</b-form-invalid-feedback
								>
							</div>
							
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.discountCode')}}</label>
								<b-form-input
									:placeholder="$t('address')"
									class="input-search price-input"
									v-model="createDiscountCodeObj.discountCode"
									id="discountCode"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.discountCode.$error }"
									:max="createDiscountCodeObj.amountType?100:''"
								></b-form-input>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please enter discount code')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.amount')}}</label>
								<b-form-input
									:placeholder="$t('phone number')"
									class="input-search price-input"
									v-model="createDiscountCodeObj.amount"
									id="amount"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.amount.$error }"
								></b-form-input>
								<b-form-invalid-feedback >
									{{createDiscountCodeObj.amountType?$t('discountList.dialog.Number must be below 100'):
									$t('discountList.dialog.Amount must be below 10,000')}} </b-form-invalid-feedback>
								<b-form-invalid-feedback 
									v-if="
									$v.createDiscountCodeObj.amount.$error&&
									(!$v.createDiscountCodeObj.amount.integer||!$v.createDiscountCodeObj.amount.numeric||
									!$v.createDiscountCodeObj.amount.required)">
									{{$t('discountList.dialog.Must be number value')}} </b-form-invalid-feedback>
							</div>
						</b-col>
						<b-col cols="6" class="align-content-end">
							<div class="form-group">
								<b-dropdown no-flip
									class="menu-dropdown"
									v-model="createDiscountCodeObj.amountType"
									id="amountType"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.amountType.$error }"
									style="margin-top:28px"
									>
									<template v-slot:button-content>
										<span>
										{{
											createDiscountCodeObj.amountType?$t('discountList.dialog.Percentage'):$t('discountList.dialog.Baht')
										}}
										<ChevronDownIcon />
										</span>
									</template>

									<b-dropdown-item
										
										@click="createDiscountCodeObj.amountType = true"
										>{{$t('discountList.dialog.Percentage')}}</b-dropdown-item
									>
									<b-dropdown-item
										
										@click="createDiscountCodeObj.amountType = false"
										>{{$t('discountList.dialog.Baht')}}</b-dropdown-item
									>
								</b-dropdown>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please select amount type')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="9">
							<div class="form-group">
								<label>{{$t('discountList.dialog.minimumOrder')}}</label>
								<div class="d-flex flex-row justify-content-center align-center" :class="{ 'is-invalid': $v.createDiscountCodeObj.minOrder.$error }">
									<b-form-input
										:placeholder="$t('phone number')"
										class="input-search price-input"
										v-model="createDiscountCodeObj.minOrder"
										id="minOrder"
										:class="{ 'is-invalid': $v.createDiscountCodeObj.minOrder.$error }"
									></b-form-input>
									<label style="margin-bottom:10px; margin-left:10px">{{$t('baht')}}</label>
								</div>
								<b-form-invalid-feedback>{{$t('discountList.dialog.Please enter minimum order amount')}}</b-form-invalid-feedback>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.limitCode')}}</label>
								<b-form-input
									:placeholder="$t('phone number')"
									class="input-search price-input"
									v-model="createDiscountCodeObj.limitCode"
									id="limitCode"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.limitCode.$error }"
								></b-form-input>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please enter limit of code can use')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.limitPerUser')}}</label>
								<b-form-input
									:placeholder="$t('Email')"
									class="input-search price-input"
									v-model="createDiscountCodeObj.limitPerUser"
									id="limitPerUser"
									:class="{ 'is-invalid': $v.createDiscountCodeObj.limitPerUser.$error }"
								></b-form-input>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please enter number for user can use discount code')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.startDate')}}</label>
								<datepicker
									class="date-input"
									:language="th"
									v-model="createDiscountCodeObj.startDate"
									:disabledDates="disabledDates"
								></datepicker>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please enter start date')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="form-group">
								<label>{{$t('discountList.dialog.endDate')}}</label>
								<datepicker
									class="date-input"
									:language="th"
									v-model="createDiscountCodeObj.endDate"
									:disabledDates="disabledDates"
								></datepicker>
								<b-form-invalid-feedback
									>{{$t('discountList.dialog.Please enter end date')}}</b-form-invalid-feedback
								>
							</div>
						</b-col>
					</b-row>
				</div>
				<div class="wrap-btn-send d-flex flex-row align-content-center justify-content-center">
					<b-button class="cancel-button" id="cancel" @click="closeAddDiscountDialog" style="width: 141px;margin-right:10px;">{{
						$t('bill.cancel')
					}}</b-button>
					<b-button
						class="btn-send success-button"
						id="save"
						type="submit"
						:disabled="loading"
						v-if="!openDialogForEdit"
						style="width: 141px;"
						>{{ $t('bill.save') }}</b-button
					>
					<b-button
						class="btn-send success-button"
						id="update"
						type="submit"
						:disabled="loading"
						v-else
						style="width: 141px;"
						>{{$t('discountList.dialog.Update')}}</b-button
					>
				</div>
			</b-form>
		</b-modal>
	</div>
</template>

<script>
// Icons
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import IconTrash from "@/components/icons/IconTrash";
import IconEdit from "@/components/icons/IconEdit";
import IconHotel from "@/components/icons/IconHotel";
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import { required, integer, numeric, maxLength } from 'vuelidate/lib/validators';
import { en, th } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";
import { helpers as vuelidateHelpers } from 'vuelidate/lib/validators'
import InfiniteLoading from 'vue-infinite-loading';

export const price_greater = (value, vm) => {
  if (!vuelidateHelpers.req(value)) {
    return true
  }
  let amountType= vm.amountType?100:10000;
 
  return parseInt(value) <= amountType;
}

export default {
	components: {
		MagnifyIcon,
		IconTrash,
		IconEdit,
		IconHotel,
		ChevronDownIcon,
		Datepicker,
		ChevronUpIcon,
		InfiniteLoading
	},
	data() {
		return {
			fields: {
				dataSource: [],
				id: "id",
				parentID: "package_id",
				text: "name",
				hasChildren: "hasChild",
			},
			config: {
				limit: 10,
				take: 10,
				page: 1,
				searchAdminMedia: ''
			},
			listOfDiscountCodes:[],
			selectedDiscountId:null,
			createDiscountCodeObj:{
				discountType:null,
				discountForPackage:[],
				discountCode:null,
				amount:null,
				amountType:false,
				minOrder:null,
				limitCode:null,
				limitPerUser:null,
				startDate:new Date(),
				endDate:new Date(),
			},
			disabledDates: {
				to: new Date(new Date().setDate(new Date().getDate() - 1)), // Disable all dates up to specific date
				from: new Date(new Date().setFullYear(new Date().getFullYear() + 1))  // Disable all dates after specific date
			},
			validateErrors: {},
			validateInputDynamic: [null],
			packagesItem:[],
			openDialogForEdit:false,
			loading:false,
			en: en,
			th: th,
		};
	},
	validations: {
		createDiscountCodeObj:{
			discountType: { required },
			discountForPackage: { required },
			discountCode: { required },
			amount: { numeric, integer, required, price_greater:price_greater},
			amountType: { required },
			minOrder: {  required, numeric, integer },
			limitCode: {numeric, integer, required },
			limitPerUser: {numeric, integer, required },
			startDate: { required },
			endDate: { required }
		}
	},
	
	
	
	filters: {
		formatDate(value, lang) {
		if (!value) return;
		let now = moment(new Date());
		let newVal = moment(value);
		// if(now.isSame(newVal, 'day')) return
		return moment(value).local("th").format("DD MMM YYYY");
		},
		formatHour(value, lang) {
		if (!value) return;
		return moment(value).local("th").format("HH:mm");
		},
	},
	computed: {
		...mapState('PackageController', ['packages']),
		...mapState('PackageController', ['coinPackages'])
	},
	methods: {
		
		...mapActions('PackageController', [
			'GET_PACKAGES','GET_COIN_PACKAGES', 'GET_AGENCY_PACKAGES'
		]),
		...mapActions('AdminDiscountCode', [
			"GET_DISCOUNT_CODE",
			"GET_DISCOUNT_CODE_DETAILS",
			"DELETE_DISCOUNT",
			"ENABLE_DISABLE_DISCOUNT_CODE",
			"UPDATE_DISCOUNT_CODE",
			"CREATE_DISCOUNT_CODE",
		]),
		
		getAllDiscountCode(){
			let obj={
				take:10,
				page:1
			};
			if(this.config.searchAdminMedia){
				obj.search=this.config.searchAdminMedia;
			}
			this.GET_DISCOUNT_CODE(obj).then((data)=>{
				console.log("data",data);
				this.listOfDiscountCodes=data.data.data;
			})
		},
		async infiniteHandler($state) {
			let response = await this.GET_DISCOUNT_CODE({
				search: this.config.searchAdminMedia || null,
				take: this.config.take,
				page: this.config.page
			});
			if (response) {
				response.data.data.forEach(elm=>{
					this.listOfDiscountCodes.push(elm)
				})
				
				if (!response.data.data) {
					return $state.complete();
				}
				if (response.data.data.length > 0) {
					this.config.take = await this.config.limit;
					this.config.page += await 1;
					await $state.loaded();
				} else await $state.complete();
			}
		},
		deleteDiscountCode(discountCode){
			console.log(discountCode)
			this.$swal({
				title: this.$t('You want to delete the announcement'),
				text: discountCode.code,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				cancelButtonColor: '#DC3849',
				confirmButtonText: this.$t('cancel'),
				cancelButtonText: this.$t('delete')
			}).then(result => {
				if (result.dismiss == 'cancel') {
					this.DELETE_DISCOUNT({id:discountCode.id}).then((data)=>{
						console.log("data",data);
						this.showToast($t('discountList.dialog.Discount Code deleted'),'success','primary');
						this.getAllDiscountCode();
					}).catch(err=>{
						console.log(err)
						this.showToast(err.data.detail,'Error','danger')
					})
				}
			})
		},
		editDiscountCode(item) {
			this.resetForm();
			this.selectedDiscountId=item.id;
			this.openDialogForEdit=true;
			this.GET_DISCOUNT_CODE_DETAILS({id:item.id}).then((data)=>{
				let a=[];
				this.createDiscountCodeObj.discountType=data.data.data.is_listing?1:2;
				this.createDiscountCodeObj.amount=data.data.data.amount;
				this.createDiscountCodeObj.amountType=!data.data.data.is_fix_amount;
				this.createDiscountCodeObj.minOrder=data.data.data.minimum_amount;
				this.createDiscountCodeObj.limitCode=data.data.data.max_usages;
				this.createDiscountCodeObj.limitPerUser=data.data.data.max_usages_per_user;
				this.createDiscountCodeObj.startDate=new Date(data.data.data.start_date);
				this.createDiscountCodeObj.endDate=new Date(data.data.data.expire_date).setDate(new Date().getDate() + 7);
				this.createDiscountCodeObj.discountCode=data.data.data.code;
				
				data.data.data.discount_code_packages.forEach((elm)=>{
						console.log("elm",elm)
						if(data.data.data.is_listing){
							a.push(elm.listing_package_id);
						}
						else{
							a.push(elm.package_general_id);
						}
				})
				
				console.log("this.createDiscountCodeObj.discountForPackage",this.createDiscountCodeObj.discountForPackage)
				
				if(data.data.data.is_listing?this.packages:this.coinPackages){
					setTimeout(()=>{
						this.createDiscountCodeObj.discountForPackage =a;
						this.$forceUpdate();
						this.showDialog();
					},100)
				}
			}).catch(err=>{
				console.log("err",err)
				this.showToast(err.data.detail,'Error','danger')
			})
			
		},
		showDialog(){
			this.$bvModal.show('add-discount');
		},
		resetForm(){
			this.createDiscountCodeObj={
				discountType:null,
				discountForPackage:[],
				discountCode:null,
				amount:null,
				amountType:false,
				minOrder:null,
				limitCode:null,
				limitPerUser:null,
				startDate:new Date(),
				endDate:new Date(),
			}
		},
		createDiscountCode() {
			this.openDialogForEdit=false;
			this.resetForm();
			this.$v.createDiscountCodeObj.$touch=false;
			this.showDialog();
		},
		closeAddDiscountDialog() {
			this.$bvModal.hide('add-discount');
		},
		getListingPackage(){
			this.packagesItem=[];
			this.GET_PACKAGES({
			take: 10,
			page: 1
			}).then(result => {
				console.log("result",result)
				console.log("this.coinPackages",this.packages)
				this.packagesItem=this.packages;
			});
		},
		getCoinPackage(){
			this.packagesItem=[];
			this.GET_COIN_PACKAGES({
				take: 10,
				page: 1
			})
		},
		getAgencyPackage(){
			this.packagesItem=[];
			this.GET_AGENCY_PACKAGES({
				take: 10,
				page: 1
			}).then((data)=>{
				console.log("data",data);
				data.forEach((elm)=>{
					elm.packages_details=[]
					this.packagesItem.push(elm);
				})
				
			})
		},
		creatDiscountCode(){
			console.log(this.createDiscountCodeObj)
			this.$v.$touch();
			if (this.$v.$error) {
				return;
			}
			const obj={
				code : this.createDiscountCodeObj.discountCode,
				amount : this.createDiscountCodeObj.amount,
				is_percentage : this.createDiscountCodeObj.amountType,
				is_active : true,
				type : this.createDiscountCodeObj.discountType,
				max_total_usages : this.createDiscountCodeObj.limitCode,
				max_total_usages_user : this.createDiscountCodeObj.limitPerUser,
				minimum_amount_required : this.createDiscountCodeObj.minOrder,
				start_date : this.createDiscountCodeObj.startDate,
				expire_date : this.createDiscountCodeObj.endDate,
				packages_ids : this.createDiscountCodeObj.discountForPackage
			}
			console.log("obj",obj)
			this.CREATE_DISCOUNT_CODE(obj).then((data)=>{
				this.closeAddDiscountDialog();
				this.getAllDiscountCode();
				this.showToast($t('discountList.dialog.Discount Code Created'),'success','success')
				
			}).catch(err=>{
				this.showToast(err.data.detail,'Error','danger')
			})
		},
		updateDiscountCode(){
			this.$v.$touch();
			if (this.$v.$error) {
				return;
			}
			console.log(this.createDiscountCodeObj.endDate)
			const obj={

				code : this.createDiscountCodeObj.discountCode,
				amount : this.createDiscountCodeObj.amount,
				is_percentage : this.createDiscountCodeObj.amountType,
				is_active : true,
				type : this.createDiscountCodeObj.discountType,
				max_total_usages : this.createDiscountCodeObj.limitCode,
				max_total_usages_user : this.createDiscountCodeObj.limitPerUser,
				minimum_amount_required : this.createDiscountCodeObj.minOrder,
				start_date : this.createDiscountCodeObj.startDate,
				expire_date : this.createDiscountCodeObj.endDate,
				packages_ids : this.createDiscountCodeObj.discountForPackage,
				id:this.selectedDiscountId
			}
			this.UPDATE_DISCOUNT_CODE(obj).then((data)=>{
				this.closeAddDiscountDialog();
				this.getAllDiscountCode();
				this.showToast($t('discountList.dialog.Discount Code updated'),'success','success')
			}).catch(err=>{
				this.showToast(err.data.detail,'Error','danger')
			})
		},
		updateEnabaleOrDisable(item){
			console.log("item",item);
			this.ENABLE_DISABLE_DISCOUNT_CODE({id:item.id}).then((data)=>{
				this.getAllDiscountCode();
				this.showToast($t('discountList.dialog.Discount Code updated'),'success','success')
			}).catch(err=>{
				this.showToast(err.data.detail,'Error','danger')
			})
		}, 
		showToast(message,title,type){
			this.$bvToast.toast(message, {
				title: title,
				variant: type,
				solid: true
			});
		}

	},
	watch:{
		'config.searchAdminMedia': {
			deep: true,
			handler: _.debounce(function () {
				this.config.page = 1;
				this.$forceUpdate();
				
			}, 800),
		},
		'createDiscountCodeObj.discountType'(val){
			this.createDiscountCodeObj.discountForPackage=[];
			this.fields.dataSource=[];
			if(val==1){
				this.getListingPackage();
			}else if(val == 2){
				this.getCoinPackage();
			}else{
				this.getAgencyPackage();
			}
		},
		
		coinPackages(val){
			console.log("val",val)
			val.forEach((element)=>{
				element.packages_details=[]
				this.packagesItem.push(element);
				
			})
		}
	},
};
</script>
<style lang="scss" >
@import 'adminDiscountList.scss';
</style>
